import i18n from "lang/i18n";
function getFullName(last_name: string, first_name: string): string {
    const lang = i18n.language;
    //console.log('lang', lang, last_name, first_name)
    if (lang === 'en') {
        return first_name + ' ' + last_name;
    } else {
        return last_name + ' ' + first_name;
    }

}

export { getFullName }